export const sortMapByStringValue = (myMap: Map<number, string>): Map<number, string> => {
    return new Map([...myMap.entries()].sort(([k, v], [k2, v2]) => v.localeCompare(v2)));
};

export const sortMapByStringKey = (kommuneMap: Map<string, number>): Map<string, number> => {
    return new Map([...kommuneMap.entries()].sort(([k, v], [k2, v2]) => k.localeCompare(k2)));
};